import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import AppTitle from '../../../layouts/AppTitle';
import { blogBg, saycheezeAbout2, shopBg } from '../../../../assets/images';
import { getPageContent } from '../../../../store/actions/ProductActions';

import { useDispatch, useSelector } from 'react-redux';
import AppLoader from '../../../pages/AppLoader';
import moment from 'moment';
import BlogCard from './BlogCard';
import { Alert } from '@mui/material';
import { Link } from 'react-router-dom';

const BlogList = () => {
  const dispatch = useDispatch();
  const myDivRef = useRef(null);

  const blogs = useSelector(state => state?.products?.blogs);
  const topBlogs = blogs?.filter(b => b?.isTopBlog);

  useEffect(() => {
    dispatch(getPageContent('getAllBlogs'));
  }, []);

  useEffect(() => {
    if (blogs?.length > 0) {
      scrollToProducts();
    }
  }, [blogs]);

  function scrollToProducts() {
    if (myDivRef.current) {
      myDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return blogs ? (
    <div>
      <Helmet>
        <title>Cake & Dessert Blogs – Tips, Ideas & Inspiration</title>
        <meta
          name='description'
          content='Read blogs from SayCheeze Cakes on cake ideas, celebration tips, baking inspiration, and dessert trends to make your special moments sweeter.'
        />
        <link rel='canonical' href='https://www.saycheezecakes.com/blog' />
      </Helmet>

      <AppTitle title='Blogs' from='Home' link='/' to='Shop' bgImg={blogBg} />

      {blogs?.length === 0 ? (
        <div className='container my-5'>
          <Alert icon={false} sx={{ mb: 2 }} severity='success' color='warning'>
            Currently, no blogs are available.
          </Alert>
        </div>
      ) : (
        <div class='blog-sidebar blog-sidebar-right' ref={myDivRef}>
          <div class='container'>
            <div class='row'>
              <div class='col-xl-9 col-lg-8 col-12 section-padding-04 order-1 order-lg-2'>
                <div class='blog-sidebar_ml'>
                  {blogs?.map((blog, i) => (
                    <BlogCard key={i} blog={blog} hideDesc={true} />
                  ))}
                </div>
              </div>
              <div class='col-xl-3 col-lg-4 col-12 order-2 order-lg-1 d-none d-md-block'>
                <div class='sidebars'>
                  <div class='sidebars_inner'>
                    <div class='sidebars_widget'>
                      <h3 class='sidebars_widget__title'>Popular blogs</h3>
                      <ul class='sidebars_widget__post'>
                        {topBlogs?.map(blog => (
                          <li class='single-post'>
                            <a href='#' class='single-post_thumb'>
                              <img src={blog?.files?.[0]?.path} alt='Sidebar-Image' />
                            </a>
                            <div class='single-post_content'>
                              <span class='single-post_content__meta'>
                                {moment(blog?.createdAt).format('MMMM DD, yyyy')}
                              </span>
                              <Link to={`/blog/${blog?._id}`} class='single-post_content__title'>
                                {blog?.title}
                              </Link>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {topBlogs?.[0]?.files?.[0]?.path && (
                      <div class='sidebars_widget'>
                        <a href='#' class='sidebars_widget__banner'>
                          <img src={saycheezeAbout2} alt='banner-Image' />

                          <div class='banner-content'>
                            <span class='banner-content_title'></span>
                          </div>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : (
    <AppLoader />
  );
};

export default BlogList;
